import { translate } from 'loankeeper-common/helpers'

import { General, SomeOther } from './Info'
import { formName } from './constants'

const icon = (objectName) => `${formName}/${objectName}`

const tabs = {
  general: {
    title: () => translate('frm_account_view-tb_general'),
    name: 'general',
    component: General,
    api: 'base',
    icon: icon('tb_general'),
  },

  someOther: {
    title: () => translate('frm_account_view-tb_access'),
    name: 'someOther',
    component: SomeOther,
    api: ['base', { page: 'permslist', permission: 'VIEW_RL' }],
    icon: 'frm_loan_view/tb_other',
  },
}

export default () => tabs
